import { render, staticRenderFns } from "./InterviewCard.vue?vue&type=template&id=86f44b10&scoped=true"
import script from "./InterviewCard.vue?vue&type=script&lang=js"
export * from "./InterviewCard.vue?vue&type=script&lang=js"
import style0 from "./InterviewCard.vue?vue&type=style&index=0&id=86f44b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f44b10",
  null
  
)

export default component.exports